import { connect } from 'react-redux';

import ExternalLinksFormComponent from './ExternalLinksFormComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';
import {
  clearExternalLink,
  createExternalLink,
  getExternalLink,
  updateExternalLink,
} from './actions';

import { getBuildingFilterOptions } from '../../Amenity/utils';

import { getExternalAccountById } from '../selectors';

import { history } from '../../../store';

const form = 'ExternalLinksForm';

const mapStateToProps = (state, ownProps) => {
  const accountId = ownProps?.match?.params?.id;
  const account = getExternalAccountById(accountId)(state);
  const buildings = getBuildingFilterOptions(state?.buildings);
  let initialValues;

  if (account) {
    initialValues = { ...account };
  }
  return {
    accountId,
    initialValues,
    form,
    buildings,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const accountId = ownProps?.match?.params?.id;
  return {
    onLoad: () => {
      getBuildingsForFilter(dispatch);
      accountId && getExternalLink(dispatch, accountId);
    },
    onSubmit: async (data) => {
      const res = accountId
        ? await updateExternalLink(dispatch, accountId, data)
        : await createExternalLink(dispatch, data);
      res && history.goBack();
    },
    onUnmount: () => {
      clearExternalLink(dispatch);
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExternalLinksFormComponent);
